import { Description } from "./styles";

import SectionContainer from "../../ui/SectionContainer";
import HighlightBand from "../../ui/HighlightBand";

import Illustration from "../../../assets/images/sections/esp-academy/illustration.png";
import BackgroundImage from "../../../assets/images/sections/esp-academy/background.jpg";
import AcademyLogo from "../../../assets/images/branding/logo-academy.svg";

const EspAcademy = () => {
  return (
    <SectionContainer
      backgroundImage={BackgroundImage}
      id="academy"
      backgroundPosition="bottom"
    >
      <img src={Illustration} alt="imagem" />
      <Description>
        <img src={AcademyLogo} alt="logo" />

        <p>
          A{" "}
          <HighlightBand background="">
            <span>ESP Academy</span>
          </HighlightBand>{" "}
          é um curso imersivo com foco na nossa metodologia para educadores
          físicos e professores que buscam atualização, prática e novos olhares
          sobre o ensino esportivo.
        </p>
        <p>
          Acontece duas vezes por ano, em janeiro e julho, e é aberto a todos os
          profissionais da área, professores da ESP ou de outras escolas, além
          de estudantes de Educação Física.
        </p>
      </Description>
    </SectionContainer>
  );
};

export default EspAcademy;
